import {useMutation} from "@tanstack/react-query";
import {createInv} from "../../../../../api/inventory/InvApi";
import {InvCreateType} from "../interface";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import useGoToNavigation from "../../../../../util/useGotoNavigation";

export const useCreateInv = () => {
    const {goToNavigation} = useGoToNavigation();
    const {handleModal} = useModal();

    const {mutate} = useMutation({
        mutationFn: (data: InvCreateType) => createInv(data),
        onSuccess: (res: any) => {
            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "등록되었습니다.",
                    type: "alert",
                    closeAction: () => {
                        goToNavigation(`inventory/inv/detail/${res.data.result.inventoryId}`, {}, false)
                    }
                });
            } else {
                handleModal({
                    isOpen: true,
                    contents: res.data.message ?? res.data.msg,
                    type: "alert",
                });
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
